import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { IWidgetDialogItemProps } from './types';
import { storeUserWidgetVisibility } from '../../../../../../app/page/page-storage/user-settings/user-settings.actions';

export const WidgetDialogItem: FunctionComponent<IWidgetDialogItemProps> = ({ widget, provided }) => {
  const dispatch = useDispatch();
  const visible = widget.visible;
  const toggle = useCallback(() => {
    if (visible) {
      dispatch(storeUserWidgetVisibility(widget.key, false));
    } else {
      dispatch(storeUserWidgetVisibility(widget.key, true));
    }
  }, [dispatch, visible, widget.key]);
  return (
    widget && (
      <div
        id={widget.key}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref={provided.innerRef}
        draggable={true}
        className="one-widget"
      >
        <div className="one-widget-container">
          <i className="icon-hamburger" />
          <h3>{widget.title}</h3>
          <i style={{ cursor: 'pointer' }} onClick={toggle} className={`icon-eye ${visible ? '' : 'toggled'}`} />
        </div>
      </div>
    )
  );
};
